import React, { Component } from "react";
import styles from "./monitoringTaskTripUnitsBar.module.scss";
import TooltipWrapper from "../../../../shared/items/contols/tooltipWrapper";
import { withUnits } from "../../../../shared/containers/containerUnits";
import { getCarsTypeName } from "../../../sections/cars/static.carsTypes";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { withMonitoringTaskTrips } from "../../../../shared/containers/containerLogisticMonitoringsTaskTrips";

class MonitoringTripUnitItem extends Component {
  onClickHandler() {
    const { monitoringSettingsState, onSetMonitoringSettingsState, data, monitoringTaskTrip } = this.props;

    if (monitoringSettingsState.isModificating) return;

    if (monitoringSettingsState.unitState !== null) {
      monitoringSettingsState.unitState.unitId = data.id;
      monitoringSettingsState.unitState.unitTitle = data.unit.title;
      monitoringSettingsState.unitState.unitRegisterNumber = data.unit.registerNumber;
    } else {
      monitoringSettingsState.unitState = {
        id: monitoringTaskTrip.id,
        title: monitoringTaskTrip.title,
        unitId: data.id,
        unitTitle: data.unit.title,
        unitRegisterNumber: data.unit.registerNumber,
        routeId: null,
        controlPointId: null,
      };
    }

    onSetMonitoringSettingsState(monitoringSettingsState);
  }

  render() {
    const { data, monitoringTaskTrip, monitoringSettingsState } = this.props;

    if (monitoringTaskTrip === null) return <div></div>;

    const getStatusStyles = () => {
      switch (data.unit.inActive ? "inActive" : getCarsTypeName(data.status.id)) {
        case "noData":
          return styles.container_carNumber_noData;
        case "inMove":
          return styles.container_carNumber_inMove;
        case "parking":
          return styles.container_carNumber_parking;
        case "inActive":
          return styles.container_carNumber_inActive;
        default:
          return null;
      }
    };

    const isCheck = monitoringTaskTrip.units.some((x) => {
      return x.id === data.id;
    });
    
    const isCheckToAdd = monitoringSettingsState.unitState !== null && monitoringSettingsState.unitState.unitId === data.id;

    return (
      <div className={styles.carsListItemWrapper} key={isCheck + data.id}>
        <div className={styles.container_carsListItemWrapper}>
          <div className={styles.carsListItem}>
            <TooltipWrapper title={data.status.title} position="right">
              <div className={getStatusStyles()}>
                <span className={styles.title}>{data.number}</span>
              </div>
            </TooltipWrapper>

            <div className={styles.carsListItemInner}>
              <div className={styles.container_carContent}>
                <div className={styles.container_name}>
                  <div>{data.unit.title}</div>

                  <div>{data.unit.registerNumber}</div>
                </div>
              </div>

              <div className={styles.container_params}>
                {isCheck || isCheckToAdd ? (
                  <div className={styles.container_itemChecked} style={{ color: isCheckToAdd ? "#f7bf47" : null }}>
                    <CheckCircleIcon fontSize="small" />
                  </div>
                ) : (
                  <TooltipWrapper title={`Назначить на рейс ${data.unit.title} ${data.unit.registerNumber}`} position="top">
                    <div
                      className={styles.container_itemUnchecked}
                      onClick={(e) => {
                        e.stopPropagation();
                        this.onClickHandler();
                      }}
                    >
                      <CheckCircleOutlineIcon fontSize="small" />
                    </div>
                  </TooltipWrapper>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withMonitoringTaskTrips(withUnits(React.memo(MonitoringTripUnitItem)));
